<div class="wizard-content-container">
    <div class="section-header layout-row removeSectionHeader" *ngIf="contentTitle">
        <div class="rowPaddingLeft">
            {{contentTitle}}
        </div>
    </div>
    <div  class="content-area">
        <ng-content></ng-content>
    </div>
  </div>